import {$setToken,$post, $Login} from '../utils/request'
import {message} from 'ant-design-vue'


export const $login =async(params)=>{
    console.log(params)
    
    if(!params.mobile){
        return false;
    }
    let d=await $Login('/login.do',params)
    console.log(d)
    //从响应中获取code和message
    let code=d.code
    let msg=d.msg;
   
    
    if(code === 'success'){
        let user =d.data.coach;
        let good_at_list =d.data.good_at_list;
        let area_list =d.data.area_list;
        console.log("***************************user***************************")
        console.log(user)
        console.log(area_list)
        console.log(good_at_list)
        console.log("***************************user***************************")
        localStorage.setItem("good_at_list",JSON.stringify(good_at_list));
        localStorage.setItem("area_list",JSON.stringify(area_list));
        if(!params.reLoginFlag){
            message.success(msg)
        }
         //如果登陆成功，后台会返回一个token,需要把token存下来，后期每次请求带上
       //  {"code":"success","msg":"操作成功","data":{"id":1,"type":"1","name":"李老师","mobile":"15800670467","passwd":"E10ADC3949BA59ABBE56E057F20F883E","token":"4b8e9adcfd9148e6a9c961662a577fcd","desc":null,"team_id":null,"team_name":null,"good_at":null,"area":null,"list":[]}}
         localStorage.setItem("mobile",params.mobile);
         localStorage.setItem('token',user.token)
         localStorage.setItem('username',user.name)
         localStorage.setItem('userInfo',JSON.stringify(user))
         
         if(params.remember==true || params.remember=='true'){
            console.log("1")
            localStorage.setItem("mobile",params.mobile);
            localStorage.setItem("passwd",params.passwd);
            localStorage.setItem("remember",params.remember);
         }else{
            console.log("2")
         }
         //设置请求头
         $setToken(user.token)
    
    }else{
        message.error(msg);
    }
    //将应答码返回给login页面做跳转
    return code;
   
}



export const $reLogin =async()=>{
    let params={}
    params.username=localStorage.getItem("username");
    params.password=localStorage.getItem("password");
    params.remember=localStorage.getItem("remember");
    params.reLoginFlag="1"
    let res=await $login(params)
    //将应答码返回给login页面做跳转
    return res;
}